(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-dashboard"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const dashboard = document.querySelector('.account-dashboard.legendary-edition');
  if (!dashboard) return;

  // ============================================
  // DARK MODE SYSTEM
  // ============================================
  (function initDarkMode() {
    const toggle = document.getElementById('darkModeToggle');
    const mobileToggle = document.getElementById('mobileThemeToggle');
    const STORAGE_KEY = 'vhg-dashboard-theme';

    function getInitialTheme() {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return stored;
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    function applyTheme(theme) {
      dashboard.setAttribute('data-theme', theme);
      localStorage.setItem(STORAGE_KEY, theme);

      // Update tier glow RGB based on tier
      const tierRank = dashboard.getAttribute('data-tier');
      const glowColors = {
        '0': '111, 159, 111',
        '1': '111, 159, 111',
        '2': '8, 145, 178',
        '3': '234, 88, 12',
        '4': '220, 38, 38',
        '5': '147, 51, 234'
      };
      dashboard.style.setProperty('--tier-glow-rgb', glowColors[tierRank] || glowColors['0']);
    }

    // Initialize theme
    applyTheme(getInitialTheme());

    // Toggle handlers
    function handleToggle() {
      const current = dashboard.getAttribute('data-theme');
      applyTheme(current === 'dark' ? 'light' : 'dark');
    }

    if (toggle) toggle.addEventListener('click', handleToggle);
    if (mobileToggle) mobileToggle.addEventListener('click', handleToggle);

    // Listen for system preference changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function(e) {
      if (!localStorage.getItem(STORAGE_KEY)) {
        applyTheme(e.matches ? 'dark' : 'light');
      }
    });
  })();

  // ============================================
  // EMAIL TOOLTIP (for truncated emails)
  // ============================================
  (function initEmailTooltip() {
    const emailEl = dashboard.querySelector('.detail-value-email[data-tooltip]');
    if (!emailEl) return;

    const tooltip = document.createElement('div');
    tooltip.className = 'email-tooltip';
    tooltip.style.cssText = `
      position: fixed;
      background: #1a1a2e;
      color: #ffffff;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 13px;
      white-space: nowrap;
      z-index: 10000;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.2s ease;
    `;
    document.body.appendChild(tooltip);

    emailEl.addEventListener('mouseenter', function(e) {
      const email = this.getAttribute('data-tooltip');
      tooltip.textContent = email;
      tooltip.style.opacity = '1';

      const rect = this.getBoundingClientRect();
      tooltip.style.left = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2) + 'px';
      tooltip.style.top = (rect.top - tooltip.offsetHeight - 8) + 'px';
    });

    emailEl.addEventListener('mouseleave', function() {
      tooltip.style.opacity = '0';
    });
  })();

  // ============================================
  // COLLAPSIBLE DEFAULT ADDRESS (only when long)
  // ============================================
  (function initAddressCollapsible() {
    const blocks = dashboard.querySelectorAll('[data-address-collapsible]');
    if (!blocks.length) return;

    function updateOverflowState(block) {
      const summary = block.querySelector('[data-address-summary]');
      const toggle = block.querySelector('[data-address-toggle]');
      const full = block.querySelector('[data-address-full]');
      if (!summary || !toggle || !full) return;

      const isOverflowing = summary.scrollWidth > summary.clientWidth + 1;
      toggle.hidden = !isOverflowing;

      if (!isOverflowing) {
        block.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        full.hidden = true;
      }
    }

    blocks.forEach((block) => {
      const toggle = block.querySelector('[data-address-toggle]');
      const full = block.querySelector('[data-address-full]');
      if (!toggle || !full) return;

      toggle.addEventListener('click', () => {
        const isExpanded = block.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        full.hidden = !isExpanded;
      });

      updateOverflowState(block);
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        blocks.forEach(updateOverflowState);
      }, 150);
    });
  })();

  // ============================================
  // QUICK ADD TO CART (Quick Reorder Section)
  // ============================================
  (function initQuickAdd() {
    const reorderCards = dashboard.querySelectorAll('.reorder-product-card');
    if (!reorderCards.length) return;

    reorderCards.forEach(card => {
      const minusBtn = card.querySelector('.qty-minus');
      const plusBtn = card.querySelector('.qty-plus');
      const qtyInput = card.querySelector('.qty-input');
      const addBtn = card.querySelector('.quick-add-btn');

      if (!minusBtn || !plusBtn || !qtyInput || !addBtn) return;

      // Quantity controls
      minusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal > 1) {
          qtyInput.value = currentVal - 1;
        }
      });

      plusBtn.addEventListener('click', () => {
        const currentVal = parseInt(qtyInput.value) || 1;
        if (currentVal < 99) {
          qtyInput.value = currentVal + 1;
        }
      });

      qtyInput.addEventListener('change', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (val < 1) val = 1;
        if (val > 99) val = 99;
        qtyInput.value = val;
      });

      // Quick add to cart
      addBtn.addEventListener('click', async () => {
        const variantId = addBtn.dataset.variantId;
        const quantity = parseInt(qtyInput.value) || 1;

        if (!variantId) return;

        addBtn.classList.add('adding');
        const btnText = addBtn.querySelector('.btn-text');
        const originalText = btnText.textContent;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });

          if (response.ok) {
            addBtn.classList.remove('adding');
            addBtn.classList.add('added');
            btnText.textContent = 'Added!';

            // Fetch updated cart and update all cart count elements
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();

            // Update cart count elements (multiple selectors for different themes)
            const cartCountSelectors = [
              '.cart-count-bubble span',
              '.cart-count-bubble',
              '[data-total-cart-item]',
              '[data-cart-count]',
              '.cart-count',
              '.header-cart-count'
            ];

            cartCountSelectors.forEach(selector => {
              document.querySelectorAll(selector).forEach(el => {
                if (el.tagName === 'SPAN' || el.hasAttribute('data-total-cart-item')) {
                  el.textContent = cartData.item_count;
                } else if (el.classList.contains('cart-count-bubble')) {
                  const span = el.querySelector('span');
                  if (span) span.textContent = cartData.item_count;
                }
              });
            });

            // Show cart count bubble if it was hidden (cart was empty)
            document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
              if (cartData.item_count > 0) {
                bubble.style.display = '';
                bubble.removeAttribute('hidden');
              }
            });

            // Trigger theme's pub/sub cart update if available
            if (typeof theme !== 'undefined' && theme.pubsub && theme.pubsub.publish) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'quick-reorder',
                productVariantId: variantId,
                cartData: cartData
              });
            }

            // Reset button after 2 seconds
            setTimeout(() => {
              addBtn.classList.remove('added');
              btnText.textContent = originalText;
            }, 2000);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          addBtn.classList.remove('adding');
          btnText.textContent = 'Error';
          setTimeout(() => {
            btnText.textContent = originalText;
          }, 2000);
        }
      });
    });
  })();

  // ============================================
  // OPTIMIZED PARTICLE SYSTEM (30fps cap, reduced count)
  // ============================================
  (function initParticles() {
    const canvas = document.getElementById('particleCanvas');
    if (!canvas) return;

    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      canvas.style.display = 'none';
      return;
    }

    const ctx = canvas.getContext('2d');
    const isMobile = window.innerWidth <= 768;
    const particleCount = isMobile ? 20 : 40;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];

    class Particle {
      constructor() {
        this.reset();
      }

      reset() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.vx = (Math.random() - 0.5) * 0.3;
        this.vy = (Math.random() - 0.5) * 0.3;
        this.radius = Math.random() * 2 + 1;
      }

      update() {
        this.x += this.vx;
        this.y += this.vy;

        if (this.x < 0 || this.x > canvas.width) this.vx = -this.vx;
        if (this.y < 0 || this.y > canvas.height) this.vy = -this.vy;
      }
    }

    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle());
    }

    function getOpacity() {
      return dashboard.getAttribute('data-theme') === 'dark' ? 0.5 : 0.3;
    }

    let animationId;
    let lastTime = 0;
    const fps = 30;
    const fpsInterval = 1000 / fps;

    function animate(currentTime) {
      animationId = requestAnimationFrame(animate);

      const elapsed = currentTime - lastTime;
      if (elapsed < fpsInterval) return;
      lastTime = currentTime - (elapsed % fpsInterval);

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const opacity = getOpacity();
      const connectionDistance = 120;

      particles.forEach(function(particle) {
        particle.update();

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(111, 159, 111, ' + opacity + ')';
        ctx.fill();
      });

      // Draw connections (optimized)
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;

          if (Math.abs(dx) > connectionDistance || Math.abs(dy) > connectionDistance) continue;

          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < connectionDistance) {
            ctx.beginPath();
            ctx.strokeStyle = 'rgba(111, 159, 111, ' + (opacity * 0.5 * (1 - distance / connectionDistance)) + ')';
            ctx.lineWidth = 1;
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      }
    }

    // Pause when off-screen for performance
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (!animationId) animationId = requestAnimationFrame(animate);
        } else {
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
        }
      });
    }, { threshold: 0 });

    observer.observe(canvas);
    animationId = requestAnimationFrame(animate);

    window.addEventListener('resize', function() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });
  })();

  // ============================================
  // MAGNETIC BUTTON EFFECT (Subtle 3px max)
  // ============================================
  (function initMagneticButtons() {
    const magneticElements = document.querySelectorAll('.hero-action-btn.primary, .loyalty-shop-btn, .rewards-portal-btn, .cta-mega-btn');

    magneticElements.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        const maxMove = 3;
        const moveX = (x / rect.width) * maxMove * 2;
        const moveY = (y / rect.height) * maxMove * 2;

        this.style.setProperty('--magnetic-x', moveX + 'px');
        this.style.setProperty('--magnetic-y', moveY + 'px');
      });

      btn.addEventListener('mouseleave', function() {
        this.style.setProperty('--magnetic-x', '0px');
        this.style.setProperty('--magnetic-y', '0px');
      });
    });
  })();

  // ============================================
  // STAGGERED ENTRANCE ANIMATIONS
  // ============================================
  (function initStaggeredAnimations() {
    const statCards = document.querySelectorAll('.stat-card-premium');
    const orderItems = document.querySelectorAll('.order-mega-item-enhanced');

    // Set order index for stagger timing
    orderItems.forEach(function(item, index) {
      item.style.setProperty('--order-index', index);
    });

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    statCards.forEach(function(card) { observer.observe(card); });
    orderItems.forEach(function(item) { observer.observe(item); });
  })();

  // ============================================
  // LOYALTY AMOUNT AUTO-RESIZE
  // ============================================
  (function initLoyaltyResize() {
    const loyaltyAmount = document.querySelector('.loyalty-amount');
    if (!loyaltyAmount) return;

    function scaleLoyaltyValue() {
      const text = loyaltyAmount.textContent;
      const length = text.length;

      // Remove existing scale classes
      loyaltyAmount.classList.remove('scaled-lg', 'scaled-md', 'scaled-sm');

      // Add appropriate scale class based on length
      if (length > 10) {
        loyaltyAmount.classList.add('scaled-sm');
      } else if (length > 8) {
        loyaltyAmount.classList.add('scaled-md');
      } else if (length > 6) {
        loyaltyAmount.classList.add('scaled-lg');
      }
    }

    // Run on load
    scaleLoyaltyValue();

    // Run on window resize
    window.addEventListener('resize', scaleLoyaltyValue);
  })();

  // Dropdown functionality
  const triggers = document.querySelectorAll('.action-mega-trigger');
  
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const card = this.closest('.action-mega-card');
      const isActive = card.classList.contains('active');
      
      // Close all dropdowns
      document.querySelectorAll('.action-mega-card').forEach(function(c) {
        c.classList.remove('active');
      });
      
      // Toggle current dropdown
      if (!isActive) {
        card.classList.add('active');
      }
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.action-mega-card')) {
      document.querySelectorAll('.action-mega-card').forEach(function(card) {
        card.classList.remove('active');
      });
    }
  });

  // Animated number counter
  const statValues = document.querySelectorAll('[data-count]');
  statValues.forEach(function(stat) {
    const target = parseInt(stat.getAttribute('data-count'));
    let current = 0;
    const increment = target / 50;
    const timer = setInterval(function() {
      current += increment;
      if (current >= target) {
        stat.textContent = target;
        clearInterval(timer);
      } else {
        stat.textContent = Math.floor(current);
      }
    }, 20);
  });

  // CRITICAL: Dynamic text scaling for stat values to prevent line breaks
  function scaleStatValues() {
    const statValues = document.querySelectorAll('.stat-value-autoscale');
    
    statValues.forEach(function(element) {
      const parent = element.closest('.stat-details');
      if (!parent) return;
      
      // Get available width (accounting for padding and gaps)
      const parentWidth = parent.offsetWidth - 10;
      
      // Reset to default size first
      element.style.fontSize = '40px';
      
      // Check if text overflows
      let attempts = 0;
      while (element.scrollWidth > parentWidth && attempts < 20) {
        const currentSize = parseFloat(window.getComputedStyle(element).fontSize);
        const newSize = currentSize - 2;
        
        if (newSize < 24) break; // Don't go below 24px
        
        element.style.fontSize = newSize + 'px';
        attempts++;
      }
    });
  }

  // Run scaling on load with delay to ensure proper rendering
  setTimeout(scaleStatValues, 100);
  setTimeout(scaleStatValues, 300); // Extra delay for slow loading
  
  // Run on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scaleStatValues, 100);
  });

  // Simple scroll animations
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  document.querySelectorAll('[data-aos]').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
});
// Enhanced Order Expansion
document.querySelectorAll('.order-summary-trigger').forEach(function(trigger) {
  trigger.addEventListener('click', function(e) {
    e.stopPropagation();
    const orderItem = this.closest('.order-mega-item-enhanced');
    const isExpanded = orderItem.classList.contains('expanded');
    
    // Close all other expanded orders
    document.querySelectorAll('.order-mega-item-enhanced.expanded').forEach(function(item) {
      if (item !== orderItem) {
        item.classList.remove('expanded');
      }
    });
    
    // Toggle current order
    orderItem.classList.toggle('expanded');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-footer-accordions]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout');
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) {
        // console.error('Error: No [data-drag-button] found inside <image-comparison>.');
        return;
      }

      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.addClasses.bind(this));
        btn.addEventListener('touchstart', this.addClasses.bind(this));
      });

      // document.body.addEventListener('mouseup', this.removeClasses.bind(this));
      // document.body.addEventListener('mouseleave', this.removeClasses.bind(this));
      document.body.addEventListener('touchend', this.removeClasses.bind(this));
      document.body.addEventListener('touchcancel', this.removeClasses.bind(this));

      document.body.addEventListener('mousemove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      document.body.addEventListener('touchmove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal'
            ? e.touches[0].pageX - this.bounding.left
            : e.touches[0].pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //this.animateDrag();

              observer.disconnect();
            } else {
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    animateDrag() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      let start = performance.now();
      const totalDuration = 2000;
      let currentPos = min;

      const animateRight = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          currentPos = min + (max - min) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateRight);
        } else {
          this.movecurs(max);
          setTimeout(() => {
            this.animateToMiddle();
          }, 500);
        }
      };

      requestAnimationFrame(animateRight);
    }

    animateToMiddle() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const middle = (min + max) / 2;
      let start = performance.now();
      const totalDuration = 1000;

      const animateMiddle = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          const currentPos = max - (max - middle) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateMiddle);
        } else {
          this.movecurs(middle);
        }
      };

      requestAnimationFrame(animateMiddle);
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  */
  // Helper functions for body scroll control

  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;

      // Bind all event handlers once
      this.boundAddClasses = this.addClasses.bind(this);
      this.boundRemoveClasses = this.removeClasses.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundTouchMove = this.handleTouchMove.bind(this);
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout') || 'horizontal';
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));

      // Add temporary event listeners
      document.addEventListener('mousemove', this.boundMouseMove);
      document.addEventListener('touchmove', this.boundTouchMove, { passive: false });
      document.addEventListener('mouseup', this.boundRemoveClasses);
      document.addEventListener('mouseleave', this.boundRemoveClasses);
      document.addEventListener('touchend', this.boundRemoveClasses);
      document.addEventListener('touchcancel', this.boundRemoveClasses);
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));

      // Clean up temporary event listeners
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('touchmove', this.boundTouchMove);
      document.removeEventListener('mouseup', this.boundRemoveClasses);
      document.removeEventListener('mouseleave', this.boundRemoveClasses);
      document.removeEventListener('touchend', this.boundRemoveClasses);
      document.removeEventListener('touchcancel', this.boundRemoveClasses);
    }

    handleMouseMove(e) {
      if (!this.active) return;
      const x =
        this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    handleTouchMove(e) {
      if (!this.active) return;
      e.preventDefault(); // Prevent scrolling while dragging
      const touch = e.touches[0];
      const x =
        this.layout === 'horizontal'
          ? touch.pageX - this.bounding.left
          : touch.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) return;

      // Add permanent event listeners
      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.boundAddClasses);
        btn.addEventListener('touchstart', this.boundAddClasses, { passive: true });
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    disconnectedCallback() {
      // Clean up all event listeners when component is removed
      this.iconButtons.forEach((btn) => {
        btn.removeEventListener('mousedown', this.boundAddClasses);
        btn.removeEventListener('touchstart', this.boundAddClasses);
      });
      this.removeClasses(); // Cleans up any active listeners
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
const productGridInfos = document.querySelectorAll('[data-grid-info]');
productGridInfos.forEach((gridInfo) => {
  const priceDiv = gridInfo.querySelector('.product-price');
  if (priceDiv) {
    const priceHeight = priceDiv.offsetHeight;
    gridInfo.style.setProperty('--product-price-height', `${priceHeight}px`);
  }
});


  } catch(e) { console.error(e); }
})();
})();
